import React, { Fragment } from 'react';
import Header from './Header';
import Footer from './Footer';


const PrivacyPolicy = () => {
    return (
        <Fragment>
            <Header />
            <div className="custom-banner-1">
                <div className="container">
                    <div className="custom-banner-content">
                        <div className="left-content">
                            <h1>
                                <span className="g-c-b">Your Privacy </span> Matters to Us
                            </h1>
                        </div>
                        <div className="right-content">
                            <hr
                                className="orange-line"
                                style={{ height: '5px', width: '50px', background: '#00a798', opacity: '1' }}
                            />
                            <p>
                                This Privacy Policy explains how Kumbhaatech Solutions ("we," "us," or "our") collects, uses,
                                and protects your personal information when you visit our website or use our services.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <section>
                <div className='container'>


                    <div className="privacy-content">
                        <h2>1. Information We Collect</h2>
                        <ul>
                            <li><strong>Personal Information</strong>: Name, email address, phone number, billing address, and payment details.</li>
                            <li><strong>Project-Related Information</strong>: Content, images, and other materials related to your website design project.</li>
                            <li><strong>Technical Information</strong>: IP address, browser type, device info, and browsing behavior.</li>
                            <li><strong>Cookies</strong>: Used to enhance your experience. You can disable cookies via browser settings.</li>
                        </ul>

                        <hr />

                        <h2>2. How We Use Your Information</h2>
                        <ul>
                            <li>To provide and manage our website design services.</li>
                            <li>To process payments and send invoices.</li>
                            <li>To communicate project updates and support.</li>
                            <li>To improve website performance and services.</li>
                            <li>To comply with legal obligations.</li>
                        </ul>

                        <hr />

                        <h2>3. How We Protect Your Information</h2>
                        <ul>
                            <li>We use industry-standard security practices.</li>
                            <li>Secure third-party payment gateways (e.g., PayPal, Stripe) handle transactions. We do not store card details.</li>
                        </ul>

                        <hr />

                        <h2>4. Sharing Your Information</h2>
                        <ul>
                            <li><strong>We do not sell or rent your personal data.</strong></li>
                            <li>Shared only with service providers (e.g., payment processors, hosting partners).</li>
                            <li>May be disclosed if required by law or to protect our rights.</li>
                        </ul>

                        <hr />

                        <h2>5. Your Rights</h2>
                        <ul>
                            <li>Access, update, or delete your personal information.</li>
                            <li>Opt out of marketing communications.</li>
                            <li>Request a copy of the personal data we hold.</li>
                            <li>To exercise these rights, contact us at <a href="mailto:support@kumbhatech.com">support@kumbhatech.com</a>.</li>
                        </ul>

                        <hr />

                        <h2>6. Third-Party Links</h2>
                        <p>Our website may contain links to external sites. We are not responsible for their privacy practices or content.</p>

                        <hr />

                        <h2>7. Changes to This Privacy Policy</h2>
                        <p>We may update this policy periodically. Changes will be posted on this page with the updated date.</p>
                    </div>
                </div>
            </section>
            <Footer />
        </Fragment>
    );
};

export default PrivacyPolicy;
